import { render, staticRenderFns } from "./freight_template_add.vue?vue&type=template&id=463df48a&"
import script from "./freight_template_add.vue?vue&type=script&lang=js&"
export * from "./freight_template_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports